import React from 'react';
export function Hook() {
  return <section className="w-full bg-cream" aria-labelledby="gancho-titulo" data-id="element-75" data-mp="3vc9d4p5tbcx">
      <div className="mx-auto max-w-content px-6 py-16 md:py-24" data-id="element-76" data-mp="2b7d5sdkavk98">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12" data-id="element-77" data-mp="1x6u0vfb4suba">
          <h2 id="gancho-titulo" className="font-display text-3xl font-semibold leading-tight text-plum sm:text-4xl lg:col-span-6 lg:text-[2.75rem]" data-id="element-78" data-mp="1x8dl1gzwrpic">
            ¿Sentís que a mitad de una sesión perdés el hilo y no sabés cómo
            seguir?
          </h2>

          <div className="space-y-5 border-l border-plum/15 pl-6 font-sans text-lg leading-relaxed text-ink/80 lg:col-span-6 lg:border-l-0 lg:pl-0" data-id="element-79" data-mp="2tw1rh1qlxtm2">
            <p data-id="element-80" data-mp="2k6i7fsr5rtpm">
              Muchos terapeutas dependen 100% de su intuición. Pero cuando la
              intuición se nubla, aparece la inseguridad. Te perdés en el relato
              del consultante, no sabés qué centro energético evaluar a
              continuación o, peor aún, terminás la sesión sintiendo que no
              llegaste a la raíz del problema.
            </p>
            <p data-id="element-81" data-mp="251uqyihk6stj">
              La falta de estructura no solo te agota a vos, también hace que tu
              paciente perciba falta de profesionalismo.
            </p>
            <p className="font-display text-xl font-semibold text-clay" data-id="element-82" data-mp="2jsk4hrihsk0k">
              Es hora de pasar de "hacer sesiones" a liderar procesos de
              sanación.
            </p>
          </div>
        </div>
      </div>
    </section>;
}